import * as ng from 'angular';
import { Uppercase } from './uppercase.directive';


export const UppercaseModule: string =
    ng.module('uppercase', [
    ])
        .directive('uppercase', Uppercase)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uppercase/uppercase.module.ts